import React, { useEffect, useState } from "react";
import {
  GoogleMap,
  Marker,
  useLoadScript,
  StandaloneSearchBox,
} from "@react-google-maps/api";
import { IoCloseCircleOutline } from "react-icons/io5";
import Button from "component/ui/Button";

const libraries = ["places"];
const mapContainerStyle = { width: "100%", height: "400px" };
const defaultCenter = { lat: 28.6139, lng: 77.209 }; // Default location (New Delhi)

const LocationPickerModal = ({ isOpen, onClose, onSelectLocation }) => {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY,
    libraries,
  });

  const [marker, setMarker] = useState(null);
  const [searchBox, setSearchBox] = useState(null);

  const onLoadSearchBox = (ref) => setSearchBox(ref);
  //   set current location
  useEffect(() => {
    navigator.geolocation.getCurrentPosition((pos) => {
      if (pos?.coords?.latitude && pos?.coords?.longitude) {
        setMarker({
          lat: pos?.coords?.latitude,
          lng: pos?.coords?.longitude,
        });
      }
    });
  }, []);
  const onPlacesChanged = () => {
    if (!searchBox) return; // ✅ Safety check
    const places = searchBox?.getPlaces();
    if (!places || places.length === 0) return;

    const place = places[0];
    const location = {
      lat: place.geometry.location.lat(),
      lng: place.geometry.location.lng(),
      address: place?.formatted_address,
    };
    setMarker(location);
  };

  if (!isOpen) return null;
  if (loadError) return <div>Error loading maps</div>;
  if (!isLoaded) return <div>Loading Maps...</div>;
  const handleSubmit = () => {
    onSelectLocation(marker);
  };
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg w-[90%] max-w-2xl p-4">
        <button className="float-right text-gray-500" onClick={onClose}>
          <IoCloseCircleOutline className="h-6 w-6" />
        </button>

        <div className="mt-4">
          <StandaloneSearchBox
            onLoad={onLoadSearchBox}
            onPlacesChanged={onPlacesChanged}
          >
            <input
              type="text"
              placeholder="Search location"
              className="border p-2 w-full rounded mb-2"
            />
          </StandaloneSearchBox>

          <GoogleMap
            mapContainerStyle={mapContainerStyle}
            zoom={12}
            center={marker || defaultCenter}
            onClick={(e) =>
              setMarker({
                lat: e.latLng.lat(),
                lng: e.latLng.lng(),
                address: "",
              })
            }
          >
            {marker && (
              <Marker position={{ lat: marker.lat, lng: marker.lng }} />
            )}
          </GoogleMap>
          <Button
            fullWidth
            children={"Send"}
            className={"mt-4"}
            onClick={handleSubmit}
          />
        </div>
      </div>
    </div>
  );
};

export default LocationPickerModal;
